module.exports = __webpack_public_path__ + "img/gjbs.8ecb8ca4.svg";